<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-container>
          <input
            id="usuario-id"
            type="hidden"
            v-model="usuario.id"
          />
          <input
            id="usuario-uuid"
            type="hidden"
            v-model="usuario.uuid"
          />
          <input
            id="usuario-usuario"
            type="hidden"
            v-model="usuario.usuario"
          />
          <v-row>
            <v-col
              cols="12"
              lg="3"
              md="2"
            >
              <v-text-field
                v-model="codigo"
                label="Código"
                outlined
                dense
              >
                <v-btn
                  class="btn-outer-right pa-0"
                  slot="append"
                  color="success"
                  tile
                  @click.prevent="loadDialog"
                >
                  <v-icon
                    class="mx-0"
                    color="white"
                  >
                    mdi-magnify
                  </v-icon>
                </v-btn>
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="2"
              v-if="usuario.id"
            >
              <v-checkbox
                v-model="usuario.inativar"
                label="Inativar usuário ?"
                color="success"
                v-show="mode === 'save'"
              >
              </v-checkbox>
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <v-checkbox
                v-model="usuario.deleted"
                label="Deletado ?"
                color="success"
                hide-details
                v-show="mode === 'save'"
              >
              </v-checkbox>
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <v-checkbox
                v-model="usuario.admin"
                label="Tipo admin ?"
                color="success"
                hide-details
                v-show="mode === 'save'"
              >
              </v-checkbox>
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              cols="12"
              md="3"
              v-if="codigo"
            >
              <v-btn
                color="default"
                @click.prevent="altPass"
              >
                <v-icon
                  left
                  color="green"
                >
                  mdi-account-key
                </v-icon>
                Redefinir senha
              </v-btn>
            </v-col>
          </v-row>
          <v-card>
            <v-tabs
              background-color="primary"
              dark
              v-model="tabs"
            >
              <v-tab>
                <v-icon
                  small
                  class="mx-1"
                >
                  mdi-folder-information
                </v-icon>
                Principal
              </v-tab>
              <v-tab>
                <v-icon
                  small
                  class="mx-1"
                >
                  mdi-card-account-mail
                </v-icon>
                Inf. de contato
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs">
              <v-tab-item>
                <v-card
                  flat
                  class="mt-2 pt-2"
                >
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="7"
                      md="12"
                      sm="12"
                    >
                      <v-text-field
                        v-model="usuario.nome"
                        :rules="[rules.required, rules.name]"
                        type="text"
                        label="nome *"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="3"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        v-model="usuario.data_senha"
                        type="date"
                        label="Data de vencimento senha :"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="7"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        v-model="usuario.login"
                        :rules="[rules.required]"
                        type="text"
                        label="Login *"
                        outlined
                        dense
                        hint="Campo obrigatório"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="5"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        v-model="usuario.nome_curto"
                        type="text"
                        label="Nome curto"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="px-1">
                    <v-col
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        clearable
                        v-model="usuario.email"
                        type="email"
                        required
                        label="E-mail"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        clearable
                        v-model="usuario.email_confirma"
                        type="email"
                        required
                        label="Confirmação do e-mail"
                        outlined
                        dense
                      >
                        >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    class="px-1"
                    v-if="!codigo"
                  >
                    <v-col
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        clearable
                        v-model="usuario.password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        @click:append="show1 = !show1"
                        label="Senha *"
                        hint="Deve conter pelo menos 6 caracteres"
                        required
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-text-field
                        v-model="usuario.confirmPassword"
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        required
                        :type="show2 ? 'text' : 'password'"
                        @click:append="show2 = !show2"
                        label="Confirmação da senha:"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card
                  flat
                  class="mt-2 pt-2"
                >
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-container>
        <small>* Campos indicados são obrigatórios</small>
      </v-card-text>
      <v-card-actions>
        <v-row class="mt-1">
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              color="success"
              class="ml-1 mr-4"
              v-if="mode === 'save'"
              @click.prevent="save"
            >
              <v-icon left>
                mdi-content-save-outline
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="success"
              class="ml-1 mr-4"
              v-if="mode === 'update'"
              @click.prevent="update"
            >
              <v-icon left>
                mdi-content-save-edit-outline
              </v-icon>
              Atualizar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
            <v-btn
              v-if="usuario.id"
              color="error"
              class="mr-4"
              @click="remove"
            >
              <v-icon left>
                mdi-trash-can-outline
              </v-icon>
              Deletar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar usuarios cadastradas
            </v-toolbar>
            <v-card-title>
              <v-card-title>
                Pesquisar
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Filtrar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="filtro"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  large
                  color="success"
                  class="mr-2"
                  @click="loadPessoaFilter(item)"
                >
                  mdi-arrow-down-bold-box
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-card>
    <v-card class="px-5 borda-vm">
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="editPass"
            transition="dialog-top-transition"
            max-width="470"
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Redefinição de senha
                </v-toolbar>
                <div class="form-pass mx-auto mt-1">
                  <v-form>
                    <v-row
                      justify="space-around"
                      class="px-6 mx-6"
                    >
                      <v-col cols="12">
                        <v-text-field
                          class="py-1 text-field"
                          v-model="pass.password"
                          label="Nova senha"
                          type="password"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          class="py-1 text-field"
                          v-model="pass.confirmPassword"
                          label="Confime a senha"
                          type="password"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end py-6">
                  <v-btn
                    color="success"
                    class="mr-4"
                    @click.prevent="updatePass()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false, loadClose()"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { uuid } from 'vue-uuid'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'Pessoas',
  components: {},
  computed: mapState(['user']),
  data: () => ({
    tabs: false,
    dialog: false,
    editPass: false,
    verCidade: false,
    search: '',
    uuid: '',
    mode: 'save',
    verCpf: false,
    verCnpj: false,
    codigo: '',
    tipo: 'pfisica',
    res: '',
    vLabel: '',
    dsLabel: '',
    nameLabel: '',
    color: 'null',
    error: false,
    message: '',
    fone: '(##)####-####',
    cel: '(##)#####-####',
    cep: '##.###-###',
    usuario: {},
    pass: {},
    selected: 1,
    filtro: [],
    show1: false,
    show2: true,
    password: 'Password',
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'E-mail', value: 'email' },
      { text: 'Cpf / Cgc', value: 'cgc_txt' },
      { text: 'Rg', value: 'rg' },
      { text: 'Nis', value: 'nis' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    genero: [
      { value: 'M', text: 'Masculino' },
      { value: 'F', text: 'Feminino' },
      { value: 'O', text: 'Outro' }
    ],
    rules: {
      required: value => !!value || 'Este campo é obrigatório',
      name: value => (value && value.length >= 4) || 'O nome ou razão social deve conter ao memos 4 caracteres!',
      min: value => (value && value.length >= 6) || 'A senha deve conter pelo menos 6 caracteres',
      emailMatch: () => (`A cofirmação é diferente!`),
      mailValid: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'O e-mail é invalido.'
      }
    },
    confirmPasswordRules: [
      (value) => !!value || 'Confirme a senha!'
    ],
    confirmEmailRules: [
      (value) => !!value || 'Confirme o e-mail!'
    ]
  }),
  methods: {
    save () {
      const method = this.usuario.id ? 'put' : 'post'
      const id = this.usuario.id ? `/${this.usuario.id}` : ''
      axios[method](`${baseApiUrl}/usuarios${id}`, this.usuario)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    savepes () {
      this.save()
    },
    update () {
      this.save()
    },
    updatePass () {
      const id = this.usuario.uuid
      axios.put(`${baseApiUrl}/usuarios-a4d8-e9c580/${id}`, this.pass)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.editPass = false
        })
        .catch(showError)
    },
    reset () {
      this.usuario = {}
      this.codigo = ''
      this.error = false
      this.usuario.usuario = this.user.id
      this.usuario.uuid = uuid.v1()
    },
    confirmEmail () {
      const em = this.usuario.email
      const conf = this.usuario.email_confirma
      if (em === conf) {
        this.error = false
      } else {
        this.error = true
        this.message = `A confirmação do e-mail não confere!`
      }
    },
    confirmSenha () {
      const pas = this.usuario.password
      const conf = this.usuario.confirmPassword
      if (pas === conf) {
        this.error = false
      } else {
        this.error = true
        this.message = `A confirmação da senha não confere!`
      }
    },
    limpaValidacao () {
      this.error = false
      this.message = ''
    },
    loadFiltro () {
      const url = `${baseApiUrl}/usuarios`
      axios.get(url).then(res => {
        this.filtro = res.data
      })
    },
    loadPessoaFilter (filtro, mode = 'save') {
      this.codigo = filtro.id
      const id = filtro.uuid
      this.mode = mode
      const url = `${baseApiUrl}/usuarios/${id}`
      axios.get(url).then(res => {
        this.usuario = res.data
        this.usuario.data_senha = moment(this.usuario.data_senha).format('YYYY-MM-DD')
        this.dialog = false
      })
    },
    passwordConfirmationRule () {
      return () =>
        this.usuario.password === this.usuario.confirmPassword || 'A confirmação da senha é inválida!'
    },
    emailConfirmationRule () {
      return () =>
        this.usuario.email === this.usuario.email_confirma || 'A confirmação do e-mail é inválida!'
    },
    altPass () {
      this.editPass = true
    },
    verSelect () {
      this.verCidade = false
      this.loadCidades()
    },
    loadDialog () {
      this.dialog = true
      this.loadFiltro()
    },
    loadUser () {
      this.cad = true
      this.usuario.usuario = this.user.id
      this.usuario.uuid = uuid.v1()
      this.codigo = ''
      this.usuario.email_confirma = ''
      this.usuario.email = ''
      this.usuario.password = ''
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>
<style scoped>
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-size--default {
  height: 37px !important;
  min-width: 38px !important;
}
</style>
